import { makeApiActionCreatorV3 } from '@actions/utils';

import * as api from '../api/comments';

const namespace = 'COMMENTS';

export const FETCH_COMMENTS_FOR_CASE_START = `${namespace}/FETCH_COMMENTS_FOR_CASE_START`;
export const FETCH_COMMENTS_FOR_CASE_SUCCESS = `${namespace}/FETCH_COMMENTS_FOR_CASE_SUCCESS`;
export const FETCH_COMMENTS_FOR_CASE_ERROR = `${namespace}/FETCH_COMMENTS_FOR_CASE_ERROR`;

export const fetchCommentsForCase = makeApiActionCreatorV3(
  api.fetchCommentsForCase,
  FETCH_COMMENTS_FOR_CASE_START,
  FETCH_COMMENTS_FOR_CASE_SUCCESS,
  FETCH_COMMENTS_FOR_CASE_ERROR,
);

export const INSERT_COMMENT_TO_CASE_START = `${namespace}/INSERT_COMMENT_TO_CASE_START`;
export const INSERT_COMMENT_TO_CASE_SUCCESS = `${namespace}/INSERT_COMMENT_TO_CASE_SUCCESS`;
export const INSERT_COMMENT_TO_CASE_ERROR = `${namespace}/INSERT_COMMENT_TO_CASE_ERROR`;

export const insertCommentToCase = makeApiActionCreatorV3(
  api.insertCommentToCase,
  INSERT_COMMENT_TO_CASE_START,
  INSERT_COMMENT_TO_CASE_SUCCESS,
  INSERT_COMMENT_TO_CASE_ERROR,
);

export const UPDATE_COMMENT_START = `${namespace}/UPDATE_COMMENT_START`;
export const UPDATE_COMMENT_SUCCESS = `${namespace}/UPDATE_COMMENT_SUCCESS`;
export const UPDATE_COMMENT_ERROR = `${namespace}/UPDATE_COMMENT_ERROR`;

export const updateComment = makeApiActionCreatorV3(
  api.updateComment,
  UPDATE_COMMENT_START,
  UPDATE_COMMENT_SUCCESS,
  UPDATE_COMMENT_ERROR,
);

export const DELETE_COMMENT_START = `${namespace}/DELETE_COMMENT_START`;
export const DELETE_COMMENT_SUCCESS = `${namespace}/DELETE_COMMENT_SUCCESS`;
export const DELETE_COMMENT_ERROR = `${namespace}/DELETE_COMMENT_ERROR`;

export const deleteComment = makeApiActionCreatorV3(
  api.deleteComment,
  DELETE_COMMENT_START,
  DELETE_COMMENT_SUCCESS,
  DELETE_COMMENT_ERROR,
);
